export function getToken() {
  return localStorage.getItem("token");
}

export function setToken(token) {
  return localStorage.setItem("token", token);
}

export function removeToken() {
  return localStorage.clear();
}

export function getTempUser() {
  return localStorage.getItem("tempUser");
}

export function setTempUser(tempUser) {
  return localStorage.setItem("tempUser", tempUser);
}

export function getNewUser() {
  return localStorage.getItem("newUser");
}

export function setNewUser(newUser) {
  return localStorage.setItem("newUser", newUser);
}

export function setMessageNum(num) {
  return localStorage.setItem("messageNum", num);
}

export function getMessageNum() {
  return localStorage.getItem("messageNum");
}

export function setAutoDownload(isAuto) {
  return localStorage.setItem("AutoDownload", isAuto);
}

export function getAutoDownload() {
  return localStorage.getItem("AutoDownload");
}


export function getV3Status() {
  return localStorage.getItem("status");
}

export function setV3Status(status) {
  return localStorage.setItem("status", status);
}

export function getV4Status() {
  return localStorage.getItem("status1");
}

export function setV4Status(status) {
  return localStorage.setItem("status1", status);
}
